<template>
  <div class="h-100 inbox-container d-flex">
    <div class="col-12 col-lg-4 px-0 notifications-list-wrapper h-100">
      <notifications-list
        :selected="selectedNotification && selectedNotification.id"
        @notification-click="onNotificationClick"
        :org-id="orgId"
        :key="listKey"
      >
      </notifications-list>
    </div>
    <div class="col-8 modal-container">
      <inbox-modal
        :notification="selectedNotification"
        @delete-entity="onEntityDeletion"
        @dismiss="selectedNotification = null"
        v-if="selectedNotification"
      />
      <div class="empty-state-container d-flex justify-content-center" v-else-if="hasNotifications">
        <div class="empty-state d-flex flex-column align-items-center">
          <i class="bell-empty-icon"></i>
          <div class="mt-2 text-secondary">
            Select a notification on the left to preview and reply
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InboxModal from '@/components/inbox/InboxModal'
import NotificationsList from '@/components/notifications/NotificationsList'
import * as R from 'ramda'

/**
 * This is the view for Inbox page. It shows the list of notifications. Clicking on individual shows list of activities.
 */
export default {
  name: 'Inbox',
  props: ['orgId'],
  components: {
    NotificationsList,
    InboxModal
  },
  data() {
    return {
      selectedNotification: null,
      listKey: 1
    }
  },
  computed: {
    hasNotifications() {
      const notifications = R.path(
        ['notificationCenter', this.orgId, 'notifications', 'results'],
        this.$store.state.notification
      )
      return notifications?.length > 0
    }
  },
  methods: {
    onNotificationClick({ notification }) {
      this.selectedNotification = notification
    },
    onEntityDeletion() {
      this.listKey = this.listKey + 1
      this.selectedNotification = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.inbox-container {
  background-color: $senary;
}

/deep/ .notifications-heading {
  background-color: $senary !important;
}

.notifications-list-wrapper {
  overflow: auto;
  @include scrollbarWidth($scrollSecondary);
}

.modal-container {
  padding: 20px 10px 20px 8px;
  position: relative;
}

/deep/ .notification-item {
  transition: all ease-out 100ms;
  margin-left: 8px;
  border-radius: 10px;
  border: 3px solid transparent;

  &:hover,
  &.selected {
    background-color: $selectionColor;
    border-radius: 10px;
    border: 3px solid $documentColor;
  }
}

.bell-empty-icon {
  @include dimension(50px, 50px);
}

.empty-state {
  width: 220px;
  margin-top: 200px;
  text-align: center;
}

@include media-breakpoint-down(md) {
  .modal-container {
    position: static;
  }
  /deep/ .notification-item {
    padding: 0;
  }
}
</style>
